import type { FC } from "react";
import { useTranslation } from "react-i18next";

import Video from "./Video";

interface Props {
  videoId?: string | null;
  answerType?: "success" | "warning" | "danger";
}

const AnswerVideo: FC<Props> = ({ videoId, answerType }) => {
  const { t } = useTranslation(["common"]);

  if (!videoId || (answerType !== "warning" && answerType !== "danger")) return null;

  return (
    <div className="d-flex flex-column gap-2 mt-20px">
      <strong>{t("answerVideo")}</strong>
      <Video videoId={videoId} />
    </div>
  );
};

export default AnswerVideo;
